export enum CommonActions {
  None = 0,
  Save = 1,  
  Print = 2,
  Exit = 3
}
